import { useSelector } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import TextArea from "antd/es/input/TextArea";
import { Button, Modal, Form, Radio } from "antd";
import {
  vehicleAddCommentsApiUrl,
} from "components/Common/endpoints";
import { postApis } from "components/Common/apis";

const HBComment = ({ isModalOpen, handleCloseModal, formName }) => {
  const eol = useSelector((state) => state.eol);
  const authToken = localStorage.getItem("authToken");
  const queryClient = useQueryClient();

  let initialValues = {
    key: "Is the vehicle in good condition without any issues so far?",
    testId: eol?.HBStartDetails?.testId || eol?.HBResultDetails?.testId,
    commentType: "TEXT",
    value: "yes",
    comment: "",
  };

  const addComment = async (values) => {
    const body = {
      ...initialValues,
      value: values?.value || "yes",
      comment: values?.comment,
    };

    await postApis(vehicleAddCommentsApiUrl, body, authToken)
      .then((res) => {
        if (res.status === 200) {
          toast.success('Heart Beat Test Completed', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
            closeButton: false,
          });          
          handleCloseModal();
          queryClient.invalidateQueries('hbtests');
        }
      })
      .catch((e) => {
        toast.error('Failed to add comments to Test!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          closeButton: false,
        });
        console.log('API Error--->', e.response?.data?.message);
      });
  };

  const onFinish = async (values) => {
    addComment(values);
  };

  const options = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  return (
    <>
    <Modal
      title="Vehicle Status"
      open={isModalOpen}
      closable={false}
      footer={[]}
    >
      <Form
        layout="vertical"
        initialValues={initialValues}
        onFinish={onFinish}
        name={formName}
      >
        Is the vehicle in good condition without any issues so far?
        <Form.Item key="radio" name="value">
          <Radio.Group name="value" className="mtb1">
            {options.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
        <Form.Item
          key="comment"
          name="comment"
          rules={[
            {
              required: true,
              message: "Can't be blank",
            },
          ]}
        >
          <TextArea placeholder="Comments" rows="3" data-testid="comment-input" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="comment-btn right">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
    </>
  );
};

export default HBComment;
